import { rem } from '@vimeo/bokeh';

export const getChoiceButtonSx = (isRootMenuButton = false) => ({
  justifyContent: !isRootMenuButton ? 'center' : 'flex-start !important',
  width: '100% !important',
  padding: isRootMenuButton ? '1rem 0.5rem' : '',
  height: !isRootMenuButton ? rem(40) : 'unset !important',
});

export const WrappingButtonSx = {
  ...getChoiceButtonSx(),
  padding: '0.5rem 0.75rem !important',
  height: 'unset !important',
  whiteSpace: 'normal !important',
  textAlign: 'left !important',
  wordWrap: 'break-word !important',
  overflowWrap: 'break-word !important',
};
